import capitalize from './capitalize'
import cropWords from './crop-words'
import maskCnpj from './maskCnpj'

export default { capitalize, maskCnpj, cropWords }
